var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTablerCircleX = function SvgTablerCircleX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#BBC0CE",
    cx: 12,
    cy: 12,
    r: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "m10 10 4 4m0-4-4 4"
  })));
};
export default SvgTablerCircleX;